module.exports = __webpack_public_path__ + "static/img/live-hr-advice.904b564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/screenshots/live-hr-advice.png
// module id = dvSj
// module chunks = 0